import Vue from 'vue'
function init(name, component) {
  return {
    install: function(Vue) {
      Vue.component(name, component)
    }
  }
}
function initDirectives(name, component) {
  return {
    install: function(Vue) {
      Vue.directive(name, component)
    }
  }
}


import vuxXInput from 'vux/src/components/x-input';
import vuxGroup from 'vux/src/components/group';
import vuxXButton from 'vux/src/components/x-button';
import vuxFlexbox from 'vux/src/components/flexbox/flexbox.vue';
import vuxFlexboxItem from 'vux/src/components/flexbox/flexbox-item';
import vuxPopup from 'vux/src/components/popup';
import vuxPopupHeader from 'vux/src/components/popup-header';
import vuxPicker from 'vux/src/components/picker';
import vuxPreviewer from 'vux/src/components/previewer';
import vuxTransferDom from 'vux/src/directives/transfer-dom';
import vuxXHeader from 'vux/src/components/x-header';
import vuxXDialog from 'vux/src/components/x-dialog';

const XInput = init('XInput', vuxXInput);
const Group = init('Group', vuxGroup);
const XButton = init('XButton', vuxXButton);
const Flexbox = init('Flexbox', vuxFlexbox);
const FlexboxItem = init('FlexboxItem', vuxFlexboxItem);
const Popup = init('Popup', vuxPopup);
const PopupHeader = init('PopupHeader', vuxPopupHeader);
const Picker = init('Picker', vuxPicker);
const Previewer = init('Previewer', vuxPreviewer);
const TransferDom = initDirectives('TransferDom', vuxTransferDom);
const XHeader = init('XHeader', vuxXHeader);
const XDialog = init('XDialog', vuxXDialog);

Vue.use(XInput);
Vue.use(Group);
Vue.use(XButton);
Vue.use(Flexbox);
Vue.use(FlexboxItem);
Vue.use(Popup);
Vue.use(PopupHeader);
Vue.use(Picker);
Vue.use(Previewer);
Vue.use(TransferDom);
Vue.use(XHeader);
Vue.use(XDialog);
